<template>
  <section class="forget-password-wrapper">
    <div v-if="!getVerifyPhone" class="content">
      <p class="text-title">{{ $t('form.forgotPasswordHeader')}}</p>
      <p class="text-label">{{ $t('common.emailOrPhone')}}</p>
      <!-- email  -->
      <div class="email-wrapper">
        <div class="email-input">
          <b-form-radio
            v-model="selectedInput"
            class="custom-radio"
            value="email"
          ></b-form-radio>
          <div class="input-wrapper email w-100">
            <div
              class="form-group m-d-gruop"
              :class="{
                'disabled-bg':
                  selectedInput == null ||
                  !selectedInput == 'email' ||
                  selectedInput == 'phone',
                'invalid-value': selectedInput == 'email' && $v.form.email.$error,
              }"
            >
              <b-form-input
                id="email"
                name="email"
                type="email"
                v-model="form.email"
                required
                :disabled="
                  selectedInput == null ||
                  !selectedInput == 'email' ||
                  selectedInput == 'phone'
                "
              />
              <label for="phone">{{ $t('common.email') }}</label>
            </div>
          </div>
        </div>
        <div class="err-wrapper">
          <div v-if="submitted && !$v.form.email.required">
            <span class="error-value">{{ $t('validation.requiredValidation',{value: $t('common.Email')})}}</span>
          </div>
          <div v-else-if="submitted && selectedInput == 'email' && !$v.form.email.email">
            <span class="error-value">{{ $t('validation.invalidEmail')}}</span>
          </div>
        </div>
      </div>
      <!-- phone  -->
      <div class="phone-wrapper">
        <div class="input-wrapper phone">
          <b-form-radio
            v-model="selectedInput"
            class="custom-radio"
            value="phone"
          ></b-form-radio>
          <div class="row-group phone-group justify-content-start">
            <VueCountryCode
              class="country-code-input"
              :class="{
                'disabled-bg':
                  selectedInput == null ||
                  !selectedInput == 'phone' ||
                  selectedInput == 'email',
              }"
              :disabledFetchingCountry="false"
              @onSelect="onSelectUserCountryCode"
              :enabledCountryCode="true"
              :preferredCountries="['GB', 'US', 'CN']"
              :disabled="
                selectedInput == null ||
                !selectedInput == 'phone' ||
                selectedInput == 'email'
              "
            />
            <div
              class="form-group m-d-gruop w-100"
              :class="{
                'disabled-bg':
                  selectedInput == null ||
                  !selectedInput == 'phone' ||
                  selectedInput == 'email',
                'invalid-value': selectedInput == 'phone' && $v.phone_input.$error,
              }"
            >
              <b-form-input
                id="phone"
                v-model.trim="phone_input"
                type="text"
                required
                :disabled="
                  selectedInput == null ||
                  !selectedInput == 'phone' ||
                  selectedInput == 'email'
                "
              />
              <label for="phone">{{ $t('common.phoneNumber')}}</label>
            </div>
          </div>
        </div>
        <div class="err-wrapper">
          <div v-if="submitted && !$v.phone_input.required">
            <span class="error-value">{{ $t('validation.requiredValidation',{value: $t('common.phoneNumber')})}}</span>
          </div>
          <div v-if="submitted && selectedInput == 'phone' && !$v.phone_input.numeric">
            <span class="error-value">
              {{ $t('validation.phoneDigitsOnly') }}
            </span>
          </div>
        </div>
      </div>
      <!-- action btns  -->
      <hr class="h-line" />
      <p v-if="throttleRetryAfter > 0" class="retry-countdown">
        {{ $t('auth.retryIn', { wait: retryCountdown }) }}
      </p>
      <div class="action-btns">
        <button
          class="submit-btn btn btn-primary"
          size="md"
          @click="onSubmit"
          :disabled="loadingStatus || !selectedInput || throttleRetryAfter > 0"
        >
          <i
            v-if="loadingStatus"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          <span v-else>{{ $t('common.send')}}</span>
        </button>
        <router-link tag="a" to="/login" class="btn btn-outline-danger"
          >{{ $t('common.cancel')}}</router-link
        >
      </div>
    </div>
    <!-- verify phone content  -->
    <div v-else class="verify-phone-wrapper content">
      <div class="header">
        <div class="logo">
          <img
            src="@/assets/images/logo-lg.svg"
            class="unselectable mx-auto"
            alt
            width="86px"
            height="16px"
          />
        </div>
        <p class="header-title">{{ $t('form.forgotPasswordHeader')}}</p>
      </div>
      <div class="details">
        <p class="text-title">{{ $t('validation.verifyPhone')}}</p>
        <p class="text-subtitle">{{ $t('validation.smsMsg')}}</p>
        <p v-if="invalidCode" class="invalid-code-msg">{{ $t('common.invalidCode')}}</p>
        <div class="verification-box">
          <p class="text-title">{{ $t('common.sentTo')}}</p>
          <p class="phone-number">+{{ form.phone }}</p>
          <div class="verification-code-wrapper">
            <CodeInput
              :loading="getVerifactionLoading"
              className="verification-code"
              :class="invalidCode ? 'invalid-code' : ''"
              v-on:change="onChange"
              v-on:complete="onComplete"
              @input="handleInput"
              :fields="6"
            />
          </div>
          <p v-if="verifyCounter > 0" class="counter">
            00:{{ verifyCounter >= 10 ? verifyCounter : `0${verifyCounter}` }}
          </p>
          <button
            @click="ResendCode"
            type="button"
            class="resend"
            :disabled="verifyCounter > 0"
          >
            {{ $t('common.resend')}}
          </button>
        </div>
      </div>
      <div class="actions">
        <button
          @click="onSubmitVerify"
          :disabled="
            disableSubmit || invalidCode || getVerifactionLoading
          "
          class="btn btn-primary btn-submit"
        >
          <i
            v-if="getVerifactionLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          <span v-else>{{ $t('common.verify')}}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import {
  numeric,
  maxLength,
  email,
  requiredIf,
} from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import { throttleCountdown } from "@/utils/mixins/throttleCountdown";
import VueCountryCode from "vue-country-code";
import CodeInput from "vue-verification-code-input";
import CryptoJS from "crypto-js";
var CryptoJSAesJson = {
  stringify: function (cipherParams) {
    var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function (jsonStr) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};
export default {
  mixins: [throttleCountdown],
  components: { VueCountryCode, CodeInput },
  data() {
    return {
      invalidCode: false,
      submitted: false,
      form: {
        phone: null,
        email: null,
      },
      phoneInputTyping: false,
      phone_input: null,
      userCountryCode: null,
      userId: null,
      selectedInput: "email",
      verifyCounter: 60,
      disableSubmit: true,
      verfyCode: null,
    };
  },
  computed: {
    ...mapGetters("authfack", [
      "loadingStatus",
      "getVerifyPhone",
      "getVerifactionLoading",
    ]),
    disableBtn() {
      return !this.form.email;
    },
  },
  watch: {
    "form.email"(email) {
      if (email) {
        this.$v.$touch();
      }
    },
    phone_input(phone_input) {
      this.form.phone =
        phone_input && phone_input.length > 0
          ? `${this.userCountryCode}${phone_input}`
          : null;
    },
    getVerifyPhone(value) {
      if (value) {
        this.countDownTimer();
      }
    },
    verifyCounter(counter) {
      if (counter == 0) {
        this.disableSubmit = true;
        this.verfyCode = null;
      }
    },
  },
  validations: {
    form: {
      email: {
        required: requiredIf(function () {
          const { phone_input, selectedInput } = this;
          return !phone_input && selectedInput == "email";
        }),
        email,
      },
    },
    phone_input: {
      required: requiredIf(function () {
        const {
          selectedInput,
          form: { email },
        } = this;
        return !email && selectedInput == "phone";
      }),
      numeric,
      maxLength: maxLength(50),
    },
  },
  methods: {
    ...mapActions("authfack", [
      "resetLoading",
      "forgetPassword",
      "verifyPhone",
    ]),
    onSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if ((this.selectedInput == "email" && !this.$v.form.email.$error) || (this.selectedInput == "phone" && !this.$v.phone_input.$error))
        this.forgetPassword({
          email:
            this.selectedInput == "email" ? this.form.email : this.form.phone,
        }).then(() => {
          if (
            this.selectedInput == "phone" &&
            document.getElementsByTagName("input") &&
            document.getElementsByTagName("input").length > 0
          )
            for (
              let i = 0;
              i < document.getElementsByTagName("input").length;
              i++
            ) {
              document.getElementsByTagName("input")[i].addEventListener("keyup", (e) => {
                  if (e.keyCode == 110 || e.keyCode == 46 || e.keyCode == 8) {
                    this.invalidCode = false;
                  }
                });
            }
        }).catch(() => {
          // The store surfaces the message and starts the retry countdown.
        });
    },
    ResendCode() {
      this.forgetPassword({
        email:
          this.selectedInput == "email" ? this.form.email : this.form.phone,
      });
      this.verifyCounter = 60;
      this.countDownTimer();
    },
    onSelectUserCountryCode({ dialCode }) {
      this.userCountryCode = dialCode;
    },
    onChange(value) {
      if (value.length < 6) {
        this.disableSubmit = true;
      } else if (value.length == 6) {
        this.disableSubmit = false;
      }
    },
    handleInput(e) {
      console.log("e", e);
    },
    onComplete(v) {
      this.verifyCode = v;
    },
    countDownTimer() {
      if (this.verifyCounter > 0) {
        setTimeout(() => {
          this.verifyCounter -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    onSubmitVerify() {
      const key = localStorage.getItem("serverId");
      let encryptedToken = btoa(
        CryptoJS.AES.encrypt(JSON.stringify(this.verifyCode), key, {
          format: CryptoJSAesJson,
        }).toString()
      );
      this.verifyPhone({
        token: encryptedToken,
        phone: this.form.phone,
      }).catch((err) => {
        this.invalidCode = true;
        console.log(err.response);
      });
    },
  },
  beforeMount() {
    this.resetLoading();
    localStorage.setItem("serverId", process.env.VUE_APP_PASSPORT_KEY);
  },
};
</script>

<style lang="scss" scoped>
.retry-countdown {
  margin: 0 0 12px;
  font-size: 14px;
  text-align: center;
  color: #f46a6a;
}
.invalid-code-msg {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.25px;
  text-align: center;
  color: rgba(244, 106, 106, 1);
  margin-top: 15px;
  margin-bottom: 15px;
}
.forget-password-wrapper {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    width: 579px;
    border-radius: 26px;
    background-color: #fff;
    padding: 50px 65px;
    .text-title {
      font-weight: bold;
      font-size: 17px;
      line-height: 20px;
      color: #000000;
      margin-bottom: 52px;
    }
    .text-label {
      font-size: 14px;
      margin-bottom: 16px;
      text-align: start;
      color: rgba(0, 0, 0, 0.6);
      font-weight: normal;
    }
    .custom-radio {
      margin-right: 17px;
    }
    .disabled-bg {
      opacity: 0.6;
      background-color: #f2f2f2;
      label {
        opacity: 0.2;
        color: rgba(96, 96, 96, 0.87);
        font-size: 16px;
        letter-spacing: 0.25px;
      }
    }
    .err-wrapper {
      padding-left: 48px;
      margin-top: 2px;
    }
    .phone {
      display: flex;
      align-items: center;
      .row-group {
        width: 100%;
      }
    }
    .email-wrapper {
      margin-bottom: 14px;
      .email-input {
        display: flex;
        align-items: center;
        .form-group {
          margin-bottom: 0;
        }
        .row-group {
          width: 100%;
        }
      }
    }
    .phone-wrapper {
      margin-bottom: 37px;
      .form-group {
        margin-bottom: 0;
      }
    }
    .invalid-value {
      margin-bottom: 0 !important;
    }
    input[type="text"] {
      background: #f2f2f2;
      color: #606060;
    }
    .row-group {
      display: flex;
      justify-content: space-between;
    }
  }
  .verify-phone-wrapper {
    .header {
      text-align: center;
      margin-bottom: 60px;
      .logo {
        margin-bottom: 20px;
      }
      .header-title {
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        color: rgba(0, 0, 0, 0.28);
      }
    }
    .details {
      text-align: center;
      margin-bottom: 38px;
      .text-title {
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 30px;
        letter-spacing: 0.25px;
        color: #000000;
        margin-bottom: 5px;
      }
      .text-subtitle {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        letter-spacing: 0.25px;
        margin-bottom: 27px;
        color: #666666;
      }
      .verification-box {
        background: #f2f2f2;
        border-radius: 17px;
        padding: 22px 30px;
        .text-title {
          font-weight: normal;
          font-size: 16px;
          line-height: 27px;
          text-align: center;
          letter-spacing: 0.25px;
          color: #666666;
          margin-bottom: 4px;
        }
        .phone-number {
          font-weight: bold;
          font-size: 16px;
          text-align: center;
          letter-spacing: 0.25px;
          color: #103f5e;
          margin-bottom: 24px;
        }
        .verification-code-wrapper {
          display: flex;
          justify-content: center;
          margin-bottom: 24px;
        }
        .counter {
          font-weight: normal;
          font-size: 16px;
          line-height: 27px;
          text-align: center;
          letter-spacing: 0.25px;
          color: #666666;
          margin-bottom: 4px;
        }
        .resend {
          font-weight: bold;
          font-size: 16px;
          line-height: 27px;
          letter-spacing: 0.25px;
          color: #103f5e;
          border: 0;
          outline: none;
          cursor: pointer;
          &:disabled {
            color: #96abb8;
            cursor: not-allowed;
          }
        }
      }
    }
    .actions {
      .btn-submit {
        border-radius: 22px;
        width: 100%;
        text-transform: uppercase;
        height: 44px;
        font-size: 16px;
      }
    }
  }
  .h-line {
    border: 1px solid #707070;
    background-color: #707070;
    opacity: 0.15;
    margin-bottom: 20px;
  }
  .action-btns {
    display: flex;
    justify-content: center;
    .btn {
      width: 111.69px;
      height: 33.26px;
      line-height: 15.26px;
      font-size: 16px;
      border-radius: 16.6275px;
    }
    .submit-btn {
      margin-right: 30px;
    }
  }
}
@media (max-width: 992px){
  .forget-password-wrapper{
    height: auto;
    .content{
      width: 390px!important;
    border-radius: 0px!important;
    padding: 50px 37px 50px 37px!important;
    
    .header{
      margin-bottom: 35px;
      margin-top: 23px;

      .logo{
        margin-bottom:23px ;
        margin-right: auto;
          margin-left: auto;
       img{
      width:116px!important;
      height: 22px!important;
    }
  }
  .header-title{
      font-family: 'Lato';
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      /* identical to box height */

      text-align: center;

      color: rgba(0, 0, 0, 0.28);
    }
    }
    .details{
      margin-bottom: 41px;
      .text-title{
        font-family: 'Lato';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 30px;
        /* identical to box height, or 214% */

        text-align: center;
        letter-spacing: 0.25px;

        color: #000000;
      }
      .text-subtitle{
        font-family: 'Lato';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 27px;
        /* identical to box height, or 193% */

        text-align: center;
        letter-spacing: 0.25px;

        margin-bottom: 54px;

        color: #666666;
      }
      .verification-box{
        padding: 0px!important;
        .text-title{
          font-family: 'Lato';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 27px;
          margin-bottom: 4px;
          text-align: center;
          letter-spacing: 0.25px;
          padding-top:14px;
          color: #666666;
        }
        .resend{
          font-family: 'Lato';
          font-style: normal;
          font-weight: 700;
          font-size: 14px;
          line-height: 27px;
          /* identical to box height, or 193% */

          text-align: center;
          letter-spacing: 0.25px;

          margin-bottom: 33px;


          color: #103F5E;
        }
        .phone-number{
          font-family: 'Lato';
          font-style: normal;
          font-weight: 700;
          font-size: 14px;
          line-height: 27px;
          /* identical to box height, or 193% */

          text-align: center;
          letter-spacing: 0.25px;

          margin-bottom:21px;

          color: #103F5E;
        }
        .verification-code-wrapper{
          margin-bottom:35px;

        }
      }
    }
    .actions {
      width: 309px;
      height: 37px;
      font-family: 'Lato';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 17px;
        /* identical to box height, or 106% */

        text-align: center;
        letter-spacing: 0.25px;
        text-transform: uppercase;

        color: rgba(255, 255, 255, 0.87);
        margin-bottom: 200px;
    }
    }
  } 
}
</style>
